import React from "react";
import { processStatisticsPercentage, renderm7Statistics } from "@/modules/statistics";
import { assetImg } from "@/modules/moduleImporter";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";

//note: use this.props.langdata to get language information
export default class M7 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history) {
			const total = history.length * 3;
			const filteredValues = [0, 0, 0, 0, 0, 0];
			
			history.forEach(item => {
				item.angka.split(",").forEach(num => {
					filteredValues[Number(num) - 1]++;
				});
			});
			
			filteredValues.forEach((_fil, idx) => {
				this.statisticsArray.top.push(
					<div key={`m7gst_${idx}`} className="sl-roadmap-circle">
						{ assetImg("m7", idx + 1 + "") }
					</div>
				);
				
				this.statisticsArray.bottom.push(
					processStatisticsPercentage(`m7gsb_${idx}`, filteredValues[idx], total)
				);
			});
		};
	}
	
	

	render() {
		return renderm7Statistics(this);
	}
}
